import React, { useState, useEffect } from 'react';
import { firestore } from '../config/firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import './ProfessoresList.css'; 

function ProfessorList({ searchTerm, onSelect }) {
  const [professores, setProfessores] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProfessores = async () => {
      try {
        const querySnapshot = await getDocs(collection(firestore, 'professores'));
        const professoresList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProfessores(professoresList);
      } catch (error) {
        console.error('Erro ao buscar professores:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfessores();
  }, []);

  if (loading) return <p>Carregando...</p>;

  // Filtrar a lista de professores com base no termo de pesquisa
  const filteredProfessores = professores.filter(professor =>
    professor.nome.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="professor-list-container">
      <h2></h2>
      <ul className="professor-list">
        {filteredProfessores.length > 0 ? (
          filteredProfessores.map(professor => (
            <li key={professor.id} className="professor-list-item">
              {professor.nome}
              <div>
                <Link className="view-details" to={`/professores/${professor.id}`}>Detalhes</Link>
              </div>
            </li>
          ))
        ) : (
          <p>Nenhum registro encontrado.</p>
        )}
      </ul>
    </div>
  );
}

export default ProfessorList;
